import { MapToStringPipe } from './../../shared/shared.pipe'
import { NgSelectModule } from '@ng-select/ng-select'
import { CommonModule } from '@angular/common'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { FormBuilderComponent } from './form-builder.component'
import { NgModule } from '@angular/core'
import { FormBuilderRowComponent } from './form-builder-row/form-builder-row.component'
import { FormBuilderOptionComponent } from './form-builder-option/form-builder-option.component'
import { FormPreviewComponent } from './form-preview/form-preview.component'
import { FormPreviewElementComponent } from './form-preview-element/form-preview-element.component'
import { FormPreviewMultiselectComponent } from './form-preview-multiselect/form-preview-multiselect.component'
import { ReactiveFormsModule, FormsModule } from '@angular/forms'
import { TranslateModule } from '@ngx-translate/core'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'
import { PanelModule } from '@components/panel/panel.module'
import { SharedModule } from '@shared/shared.module'
import { NumberInputModule } from '@components/number-input/number-input.module'

@NgModule({
  declarations: [
    FormBuilderComponent,
    FormBuilderRowComponent,
    FormBuilderOptionComponent,
    FormPreviewComponent,
    FormPreviewElementComponent,
    FormPreviewMultiselectComponent,
    MapToStringPipe,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    BrowserAnimationsModule,
    NgSelectModule,
    TranslateModule,
    ContentEditableModule,
    PanelModule,
    NumberInputModule,
  ],
  exports: [
    FormBuilderComponent,
    FormBuilderRowComponent,
    FormBuilderOptionComponent,
    FormPreviewComponent,
    FormPreviewElementComponent,
  ],
})
export class FormBuilderModule {}
